import React, { Component } from "react";

class TerrainStars extends Component{

    constructor(props){
        super(props)
        this.svrstars = {
            "sv_rating_no": 5,
            "color": "#e8a01899"
        }
            }
    render(){
        const ars = [];
        console.log('############### this.props.svrlocation ****************')
        console.log(this.props.svrstars)
        let n_ar = []
        for(let i=0; i <this.props.svrstars.sv_rating_no; i++ ){
            n_ar.push(i)
        }
        const sp_stars = n_ar.map((l, k)=>{
            
            return ( <span style={{color:this.props.svrstars.color}}  className="text-muted dropdown-toggle et-icon-star">
            </span>);
        });

        return (

            <div className="svr-fa-stars-content">
            <p>
           {sp_stars}
            </p>
            
        </div>
        )
    }
   
}

export default TerrainStars;